import { defineStore } from 'pinia'
import { pushToast } from '@shared/ui/kit'
import type { HuiColor } from '@shared/ui/kit'

export const useAlertStore = defineStore('alert', () => {
  type AlertType = 'info' | 'success' | 'warning' | 'error'

  // Тип уведомления → цвет UI-kit тостера (как в админке: error=красный, success=зелёный, warning=жёлтый)
  const TYPE_COLOR: Record<AlertType, HuiColor> = {
    info: 'default',
    success: 'success',
    warning: 'warning',
    error: 'danger',
  }

  // Универсальный метод для показа уведомления (новый UI-kit тостер, снизу — см. <UiKitToaster> в layout)
  function notify(
    type: AlertType,
    message: string,
    showTime: number = 5000,
    title?: string,
  ) {
    // Тосты только на клиенте
    if (typeof window !== 'undefined') {
      pushToast({
        title: title ?? (type === 'error' ? 'Ошибка' : undefined),
        description: message,
        color: TYPE_COLOR[type],
        timeout: showTime,
      })
    }
  }

  function info(message: string, showTime: number = 5000, title?: string) {
    notify('info', message, showTime, title)
  }

  function success(message: string, showTime: number = 5000, title?: string) {
    notify('success', message, showTime, title)
  }

  function warn(message: string, showTime: number = 5000, title?: string) {
    notify('warning', message, showTime, title)
  }

  function error(message: string, showTime: number = 5000, title?: string) {
    notify('error', message, showTime, title)
  }

  // alerts, remove и Alert-классы больше не нужны — уведомления показываются через <UToaster />
  return {
    notify,
    info,
    success,
    warn,
    error,
  }
})
